import { BasePageProps, BasePageState, basePageInitialState } from '../BasePage'

import { store } from '../../redux/store'

import { createReducer, createAction } from '@reduxjs/toolkit'

export interface ProfessionalPageProps extends BasePageProps {}

type ProfessionalState = {
    areaProfessionale: string | undefined
    specializzazione: string | undefined
    massimale: string | undefined
    tutela_legale: boolean | undefined
    altre_assicurazioni: string | undefined
    retroattivita: string | undefined
    tipo_assicurazione: string | undefined
    dettaglio_attivita: string | undefined
    rinnovo: boolean | undefined
    regime_medico: string | undefined
    risarcimenti: string | undefined
    direzione_sanitaria: string | undefined
    attivita_chirurgica: string | undefined
    singolo: boolean | undefined
    fatturato_precedente: number | undefined
    fatturato_attuale: number | undefined

    areaProfessionaleError: string | undefined
    specializzazioneError: string | undefined
    massimaleError: string | undefined
    tutela_legaleError: string | undefined
    altre_assicurazioniError: string | undefined
    retroattivitaError: string | undefined
    tipo_assicurazioneError: string | undefined
    dettaglio_attivitaError: string | undefined
    rinnovoError: string | undefined
    regime_medicoError: string | undefined
    risarcimentiError: string | undefined
    direzione_sanitariaError: string | undefined
    attivita_chirurgicaError: string | undefined
    singoloError: string | undefined
    fatturato_precedenteError: string | undefined
    fatturato_attualeError: string | undefined

    tipo_area_professionale: any
    tipo_area_giuridica: any
    tipo_area_medica: any
    tipo_area_tecnica: any
    tipo_direzione_sanitarie: any
    tipo_massimali: any
    tipo_regime: any
    tipo_attivita_chirurgica: any
    tipo_retroattivita: any
    tipo_risarcimenti: any
    tipo_assicurazioni: any
    tipo_professionisti: any
    tipo_altre_assicurazioni: any

    professione: string | undefined
    professioneError: string | undefined
    tipo_professioni : any
}

export type ProfessionalPageState = ProfessionalState & BasePageState

export const profPageInitialState : ProfessionalPageState = {
    ...basePageInitialState,
    ...{
        areaProfessionale: undefined,
        specializzazione: undefined,
        massimale: undefined,
        tutela_legale: undefined,
        altre_assicurazioni: undefined,
        retroattivita: undefined,
        tipo_assicurazione: undefined,
        dettaglio_attivita: undefined,
        rinnovo: undefined,
        regime_medico: undefined,
        risarcimenti: undefined,
        direzione_sanitaria: undefined,
        attivita_chirurgica: undefined,
        singolo: undefined,
        fatturato_precedente: undefined,
        fatturato_attuale: undefined,

        areaProfessionaleError: undefined,
        specializzazioneError: undefined,
        massimaleError: undefined,
        tutela_legaleError: undefined,
        altre_assicurazioniError: undefined,
        retroattivitaError: undefined,
        tipo_assicurazioneError: undefined,
        dettaglio_attivitaError: undefined,
        rinnovoError: undefined,
        regime_medicoError: undefined,
        risarcimentiError: undefined,
        direzione_sanitariaError: undefined,
        attivita_chirurgicaError: undefined,
        singoloError: undefined,
        fatturato_precedenteError: undefined,
        fatturato_attualeError: undefined,

        tipo_area_professionale: undefined,
        tipo_area_giuridica: undefined,
        tipo_area_medica: undefined,
        tipo_area_tecnica: undefined,
        tipo_direzione_sanitarie: undefined,
        tipo_massimali: undefined,
        tipo_regime: undefined,
        tipo_attivita_chirurgica: undefined,
        tipo_retroattivita: undefined,
        tipo_risarcimenti: undefined,
        tipo_assicurazioni: undefined,
        tipo_professionisti: undefined,
        tipo_altre_assicurazioni: undefined,

        professione: undefined,
        professioneError: undefined,
        tipo_professioni : undefined
    }
}

export const profUpdate = createAction<ProfessionalPageState>('prof/update')

export const profReducer = createReducer ( 
    profPageInitialState,
    (builder) => {
        builder.addCase(profUpdate, (state, action) => {
            return action.payload as ProfessionalPageState
        })
    }
)

export type ProfRootState = ReturnType<typeof store.getState>
export type ProfDispatch = typeof store.dispatch